module.exports = __webpack_public_path__ + "static/media/Scene-3.7fe3a19e.jpg";